<template>
  <el-dialog width="900px" append-to-body title="申请开票" :visible.sync="visible" :before-close="handleClose">

    <el-descriptions title="开票明细">
    </el-descriptions>
    <el-table :data="list" v-loading="loading" element-loading-text="给我一点时间" :empty-text="emptyText" border fit
      highlight-current-row>
      <el-table-column label="编号" align="center" width="80" prop="id">
      </el-table-column>
      <el-table-column label="发票项目" align="center" minWidth="150" prop="body">
      </el-table-column>
      <el-table-column label="单价" align="center" width="150">
        <template slot-scope="{row}">
          <span>{{ formatPrice(row.price || 0) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="数量" align="center" width="150">
        <template slot-scope="{row}">
          <span>{{ row.num || 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="开票总额" align="center" minWidth="180">

        <template slot-scope="{row}">
          <span>{{ formatPrice(row.price || 0) }}</span>
        </template>
      </el-table-column>
    </el-table>

    <el-form class="xm-form mgt20" autoComplete="on" :model="invoice" v-loading="loading" :rules="invoiceRules"
      element-loading-text="给我一点时间" label-position="right" ref="invoice" label-width="120px" label-suffix="：">

      <el-form-item label="选择抬头">
        <el-select placeholder="选择抬头" v-model="header_id" style="width:400px;" @change="handleChangeHeader">
          <el-option v-for="(item, index) in headerList" :key="index" :label="`${item.name}（${item.type_name}）`"
            :value="index"> </el-option>
        </el-select>
        <el-button class="mgl20" @click="handleShowAddHeader" icon="el-icon-plus">添加抬头</el-button>
      </el-form-item>

      <el-form-item label="发票类型" prop="type">
        <el-radio-group v-model="invoice.type">
          <el-radio :label="0">普通发票</el-radio>
          <el-radio :label="1">增值税专用发票</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="抬头类型" prop="header_type">
        <el-radio-group v-model="invoice.header_type">
          <el-radio :label="0">个人</el-radio>
          <el-radio :label="1">企业</el-radio>
          <el-radio :label="2">事业单位</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="发票抬头" prop="name">
        <el-input type="text" style="width:350px" v-model="invoice.name" placeholder="请输入发票抬头"> </el-input>
      </el-form-item>

      <template v-if="invoice.header_type > 0">
        <el-form-item label="纳税人识别号" prop="tax_no">
          <el-input type="text" style="width:350px" v-model="invoice.tax_no" placeholder="请输入纳税人识别号">
          </el-input>
        </el-form-item>
        <el-form-item label="开户银行名称" prop="bank_name">
          <el-input type="text" style="width:350px" v-model="invoice.bank_name" placeholder="请输入开户银行名称">
          </el-input>
        </el-form-item>
        <el-form-item label="开户银行账号" prop="bank_account">
          <el-input type="text" style="width:350px" v-model="invoice.bank_account" placeholder="请输入开户银行账号">
          </el-input>
        </el-form-item>
        <el-form-item label="营业场所地址" prop="address">
          <el-input type="text" style="width:350px" v-model="invoice.address" placeholder="请输入营业场所地址">
          </el-input>
        </el-form-item>
        <el-form-item label="注册固定电话" prop="tel">
          <el-input type="text" style="width:350px" v-model="invoice.tel" placeholder="请输入注册固定电话">
          </el-input>
        </el-form-item>
      </template>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button v-waves type="primary" @click.native.prevent="handleAddInvoice" :loading="loading">确认开票</el-button>
    </div>
    <!-- 新建发票抬头 -->
    <add-header :visible.sync="showAddForm" @getList="getAllHeaderList" />
  </el-dialog>
</template>

<script>
import { getInvoicePreview, addInvoice } from '@/api/invoice'
import { getAllHeaderList } from '@/api/header'
import waves from '@/directive/waves'; // 水波纹指令
import AddHeader from "./addHeader"
export default {
  name: 'AddInvoice',
  components: {
    AddHeader
  },
  directives: {
    waves
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    ids: {
      type: String | Number,
      required: true
    },
  },
  watch: {
    visible(value) {
      if (value) {
        this.getAllHeaderList();
        this.getInvoicePreview();
      }
    }
  },
  created() {
    this.formatPrice = this.utils.formatPrice
  },
  data() {
    return {
      loading: false,
      emptyText: '暂无数据',
      list: [],
      invoice: {
        name: '',
        type: 0,
        header_type: 0,
        bank_name: '',
        bank_account: '',
        tax_no: '',
        address: '',
        remark: '',
      },
      invoiceRules: {

      },
      header_id: null,
      headerList: [],
      showAddForm: false
    };
  },
  methods: {
    handleShowAddHeader() {
      this.showAddForm = true;
    },
    handleChangeHeader(e) {
      this.invoice = this.headerList[e]
    },
    // 开票预览
    getInvoicePreview() {
      getInvoicePreview({ ids: this.ids }).then(response => {
        this.list = response.data
      }).catch(() => {

      })
    },
    // 获取所有抬头
    getAllHeaderList() {
      getAllHeaderList({}).then(response => {
        this.headerList = response.data
        if (response.data.length > 0) {
          this.header_id = 0
          this.invoice = response.data[0]
        }
      }).catch(() => {

      })
    },
    // 新增开票
    handleAddInvoice() {
      // 验证form表单
      this.$refs.invoice.validate((valid) => {
        if (valid) {
          this.loading = true;
          const _invoice = JSON.parse(JSON.stringify(this.invoice));
          _invoice.ids = this.list.map(item => {
            return item.id
          })
          addInvoice(_invoice).then((response) => {
            this.loading = false;
            // 关闭窗口
            this.handleClose();
            // 触发父组件的callback事件
            this.$emit('getList');
            // 弹出操作提示
            this.$message({
              type: 'success',
              message: '保存成功!'
            });
          }).catch(() => {
            this.loading = false;
          });
        }
      });
    },
    // 关闭窗口
    handleClose() {
      if (this.$refs.invoice) {
        this.$refs.invoice.resetFields();
      }
      // 更新visible参数
      this.$emit('update:visible', false);
    }
  }
};
</script>

<style lang="scss" scoped></style>